import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
    name: PropTypes.string,
    helperText: PropTypes.node,
    showZero: PropTypes.bool,    
};

export default function RHFTextField({ name, helperText, showZero, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (                
                <TextField                                
                onWheel={(e)=>{
                    document.activeElement.blur();
                    return false;
                }}
                    {...field}
                    fullWidth
                    value={typeof field.value === 'number' && field.value === 0 ? (showZero ? 0 : '') : field.value}
                    error={!!error}
                    helperText={error ? error?.message : helperText}
                    {...other}
                />
            )}
        />
    );
}
